<template>
  <div id="searchLocationContainer" class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <Title class="col-md-12 mb-2" :page="page" />
        <div class="row">
          <div class="col">
            <BreadCrumb :page="page" />
          </div>
          <div class="col-1 mr-4">
            <ActionButton
              style="position:relative;bottom:20px"
              variant="outline-success mr-2"
              i="fas fa-arrow-circle-left"
              text="Regresar"
              @click="() => $router.back()"
            />
          </div>
        </div>

        <FilterRequest
          ref="filterLocation"
          :search="command"
          @getStudentEvaluationRequests="onSearchStudentEvaluation"
        />
        <Separator class="my-3" :text="page.separatorTitle" />
        <CustomResultNotFound
          v-if="showNotResults"
          class="mt-4 row pt-3"
          text="No se ha encontrado resultados."
        />
        <section v-if="studentEvaluationRequests" class="row mt-4 mx-0">
          <div class="col-12">
            <ResultRow
              v-for="(item, index) in studentEvaluationRequests"
              :key="`${item.studentSieId}-${index}`"
              :item="item"
              :filter-location="$refs.filterLocation"
              :current-page="tableConfig.currentPage"
              class="mb-4"
              :isOpen="isOpen"
              :comment-types="blogCommentTypes"
              @getStudentEvaluationRequests="getStudentEvaluationRequests"
              @onSearchStudentEvaluation="onSearchStudentEvaluation"
              @persistCoordinateAppoinmentData="persistCoordinateAppoinmentData"
            />
          </div>
          <div class="col-12">
            <Pagination
              v-if="tableConfig.totalItemCount > tableConfig.pageSize"
              :data="tableConfig"
              :page-size="tableConfig.pageSize"
              @pagination-go-page="onPageChange"
            />
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Title from '@/components/common/page/Title';
import BreadCrumb from '@/components/common/page/BreadCrumb';
import alert from '@/mixin/alert.mixin';

import FilterRequest from './components/FilterRequestManagement';
import Separator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import ResultRow from './components/ResultRow';
import Pagination from 'pagination';

//Import all information than i need
import { modulesName } from '@/modules';
import { createNamespacedHelpers } from 'vuex';
const { mapActions, mapGetters } = createNamespacedHelpers(
  modulesName.StudentEvalutionRequestManagmentModuleName
);
import ActionButton from '@/components/common/ActionButton';
import storeMixin from '@/mixin/storeGenerator';
import { getBlogCommentTypes } from "@/modules/referral/api";

export default {
  name: 'EvaluationRequestManagement',

  mixins: [alert, storeMixin],
  components: {
    Title,
    BreadCrumb,
    ActionButton,
    FilterRequest,
    Separator,
    CustomResultNotFound,
    ResultRow,
    Pagination,
  },
  data: () => ({
    moduleName: 'appointmentModule',
    savedRequestId: null,
    isOpen:false,
    page: {
      icon: 'fas fa-user-circle',
      title: 'Manejo de Coordinación a Evaluación',
      routes: ['Inicio', 'Estudiante', 'Manejo de Coordinación a Evaluación'],
      separatorTitle: 'Solicitud de Evaluación',
    },
    reasonPanelId: null,
    attachDocumentPanelId: null,
    reasonPanelMode: -1,
    command: 'getStudentEvaluationRequests',
    loadPrevFilter: false,
    blogCommentTypes: [],
  }),
  computed: {
    ...mapGetters({
      studentEvaluationRequests: 'getResults',
      tableConfig: 'getTableConfig',
    }),
    showNotResults() {
      return this.studentEvaluationRequests?.length == 0;
    },
  },
  async mounted() {
    this.fetchBlogCommentTypes();
    if (this.studentEvaluationRequests.length > 0) {
      await this.getStudentEvaluationRequests({ currentPage: 1 }, true);
    }
  },
  methods: {
    ...mapActions(['getRequests']),
    async fetchBlogCommentTypes() {
      const { data } = await getBlogCommentTypes();
      this.blogCommentTypes = data;
    },
    onCancelReferalPanel() {
      this.reasonPanelId = null;
      this.reasonPanelMode = -1;
      this.attachDocumentPanelId = null;
    },
    async onChangeStudentStatus() {
      await this.getStudentEvaluationRequests({});
    },
    async onSearchStudentEvaluation() {
      this.isOpen=false
      await this.getStudentEvaluationRequests({ currentPage: 1 });
    },
    async getStudentEvaluationRequests(oldFilters, searchForSavedFilters) {
      let startRowIndex = 0;
      //This mean is call by paging
      if (oldFilters != undefined && oldFilters.currentPage != undefined) {
        const currentPage = oldFilters.currentPage;
        startRowIndex = (currentPage - 1) * this.tableConfig.pageSize;
      }
      const advanceSearch = this.$refs.filterLocation;
      const sieId = parseInt(
        _.replace(advanceSearch.filterText, new RegExp('-', 'g'), '')
      );

      let filters = searchForSavedFilters
        ? await this.$store.state.appointmentModule.data.searchFilters
        : {
            selectedYear: advanceSearch.selectedYear,
            searchText: isNaN(sieId) ? advanceSearch.filterText : '',
            studentSie: _.isNumber(sieId) ? sieId : null,
            selectedService: advanceSearch.selectedService,
            selectedDiscipline: advanceSearch.selectedDiscipline,
            selectedStatus: advanceSearch.selectedStatus,
            selectedCenter: advanceSearch.selectedCenter,
            selectedRegion: advanceSearch.selectedRegion,
            selectedMunicipality: advanceSearch.selectedMunicipality,
            selectedSchool: advanceSearch.selectedSchool,
            orderBy: advanceSearch.orderBy,
            startRowIndex: startRowIndex, //oldFilters.currentPage,
            maxRowIndex: this.tableConfig.pageSize,
            isAdvancedFiltering: advanceSearch.isAdvancedFiltering,
          };
      this.persistLazyData({
        searchFilters: filters,
      });
      this.getRequests(filters);
    },
    async onPageChange(currentPage) {
      await this.getStudentEvaluationRequests({
        currentPage: currentPage,
      });
    },
    persistCoordinateAppoinmentData(item) {
      this.persistLazyData({
        studentSie: item.studentSieId,
        disciplineTypeId: item.disciplineTypeId,
        studentReferralId: item.studentReferralId,
        referralStatusId: item.referralStatusId,
        serviceTypeId: item.serviceTypeId,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.main-content {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  opacity: 1;
}
.btn-detail {
  color: #2db782;
  cursor: pointer;
}
.btn-detail-closed {
  color: #3f5b60;
  cursor: pointer;
}
.bg-white {
  background-color: white;
}
.top-radius {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.bottom-radius {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.bg-lightgray {
  background-color: #f2f2f2;
}
.detail-title {
  color: #5f5f5f;
}

.detail-title i {
  float: left;
  margin-right: 10px;
}

.detail-title b {
  float: left;
}
.detailBoxColor {
  background-color: #f2f2f2;
}
div .bottom-divider {
  border-bottom: 1px solid lightgray;
  border-bottom-width: thin;
}

.div-divider {
  border-top: 1px solid #cacdcf;
}

/* Status */
.short-width {
  max-width: 3%;
}

/* Table */
/* Table */
#searchLocationContainer {
  td,
  th,
  tr {
    text-align: left;
  }
  ::v-deep .vgt-searchLocation {
    thead th {
      border-top: none;
      font-weight: bold;
    }
    th {
      text-align: center;
      border-bottom: none !important;
    }
    td {
      padding: 1em 10px;
      vertical-align: top;
      text-align: left;
      font: 1rem 'Lato';
      letter-spacing: 0;
      color: #11291b;
      padding-bottom: 0;
      border-top: none !important;
    }
  }
  ::v-deep div.vgt-responsive {
    overflow-x: visible;
  }
}
.grey-border {
  border-bottom: 1px #cacdcf solid !important;
}

.custom-separator-title {
  margin-top: 35px;
}

.custom-row-information {
  float: left;
  width: 26%;
  margin-top: 20px;
  padding-left: 15px;
}

.custom-row-information b {
  font-size: 14px;
}

.custom-row-information .first-row {
  padding-bottom: 20px;
}

.custom-row-information-command {
  float: right;
  width: 18%;
  margin-top: 20px;
  padding-right: 5px;
}

.custom-row-services {
  float: left;
  margin-left: 10px;
  margin-top: 30px;
}

.custom-row-services a {
  margin-top: 10px;
  float: left;
  font-size: 10px;
  width: 100%;
}

.custom-row-services b {
  float: left;
  width: 100%;
}

.custom-row {
  background-color: #f7f7f7;
  padding-bottom: 20px;
  border-left-width: 5px;
  border-left-style: solid;
  border-radius: 5px;
}

.custom-row .border-separator {
  border-right-width: 2px;
  border-right-style: solid;
  border-right-color: #6c757d24;
  /* border-top: 16px;     */
  /* top: 10px; */
}

.custom-row-information-collapse {
  border: #f7f7f7;
  border-width: 10px;
  border-style: solid;
}

.custom-row-information-collapse-panel {
  float: left;
  margin-left: 25px;
}

.additional-info {
  padding-left: 54px;
}
label {
  color: gray;
}

p > b {
  color: dimgrey;
}
.pre-wrap {
  white-space: pre-wrap;
}

@media only screen and (max-width: 768px) {
  ::v-deep .tag-badge {
    padding-left: 0px;
    height: auto !important;
    .tag-badge-title {
      font-size: 16px;
    }
  }

  .nav-text {
    margin-top: 20px !important;
    margin-left: 17px;
  }

  .custom-row-information-collapse {
    .additional-info {
      padding-left: 11px !important;
    }
  }
}
</style>
